import React from 'react'

import { Box, Button, Tag, TagColor, Text } from '@factorialco/deprecated-design-system'
import { TransactionExpenseFragment } from 'generated/resources/graphql'
import moment from 'moment'

import DocumentType from 'modules/core/components/DocumentType'
import i18n from 'modules/core/lib/i18n'

export const Files = ({ expense }: { expense: TransactionExpenseFragment }) => {
  const [isHovered, setIsHovered] = React.useState(false)
  const background = isHovered ? 'grey100' : 'grey000White'
  const signedDocument = expense.signedDocument
  const files = [...expense.files, ...(signedDocument?.file ? [signedDocument.file] : [])]
  const isFileSigned = (file: TransactionExpenseFragment['files'][number]) => {
    return file.id === signedDocument?.file?.id
  }

  if (!files || files.length === 0) {
    return (
      <Box>
        <Text weight="medium" size="300" color="grey1000">
          {i18n.t('expenses_v2.modals.detail.files_title')}
        </Text>
        <Text.Normal>{i18n.t('expenses_v2.transactions.detail.no_files_yet')}</Text.Normal>
      </Box>
    )
  }

  return (
    <>
      <Text weight="medium" size="300" color="grey1000">
        {i18n.t('expenses_v2.modals.detail.files_title')}
      </Text>
      <Box width="full" gap="s8">
        {files.map((file) => {
          return (
            <Box
              key={file.id}
              flexDirection="row"
              justifyContent="spaceBetween"
              alignItems="center"
              background={background}
              height="s64"
              borderRadius={{ all: 'abs008' }}
              border={{
                all: {
                  width: 's1',
                  style: 'solid',
                  color: 'grey400',
                },
              }}
              gap="s8"
              padding="s8"
              cursor="pointer"
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              <Box flexDirection="row" gap="s12">
                {file.contentType && (
                  <Box justifyContent="center">
                    <DocumentType mimetype={file.contentType} />
                  </Box>
                )}
                <Box justifyContent="center">
                  <Box
                    flexDirection="column"
                    justifyContent="flexStart"
                    alignItems="flexStart"
                    gap="s4"
                  >
                    <Text.Normal ellipsis weight="semibold" size="200">
                      {file.filename}
                    </Text.Normal>
                    {isFileSigned(file) && signedDocument && (
                      <Text.Normal ellipsis size="200" color="grey700">
                        {moment.utc(signedDocument.createdAt).format('DD MMMM, YYYY')}
                      </Text.Normal>
                    )}
                  </Box>
                </Box>
              </Box>
              <Box flexDirection="row" gap="s8">
                {isFileSigned(file) && (
                  <Box justifyContent="center">
                    <Tag type={TagColor.lime}>
                      {i18n.t('expenses_v2.forms.fields.signed_document.signed')}
                    </Tag>
                  </Box>
                )}
                {file.url && (
                  <Button.Router
                    type="secondary"
                    to={file.url}
                    rel="noopener noreferrer"
                    download
                    blankTarget
                    iconName="download"
                  />
                )}
              </Box>
            </Box>
          )
        })}
      </Box>
    </>
  )
}
